import React from "react";
import { MaterialReactTable } from "material-react-table";

const DataTable = ({ table, muiTablePaperProps, muiTableContainerProps, ...props }) => {
  const mergedPaperProps = {
    elevation: 0,
    sx: {
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 3,
      overflow: "hidden",
      backgroundColor: "var(--jy-surface-1)",
      boxShadow: "var(--jy-card-shadow)",
      ...(muiTablePaperProps?.sx || {}),
    },
    ...muiTablePaperProps,
  };

  const mergedContainerProps = {
    sx: {
      maxHeight: "70vh",
      ...(muiTableContainerProps?.sx || {}),
    },
    ...muiTableContainerProps,
  };

  return (
    <MaterialReactTable
      table={table}
      muiTablePaperProps={mergedPaperProps}
      muiTableContainerProps={mergedContainerProps}
      {...props}
    />
  );
};

export default DataTable;
